import { Route } from "react-router-dom";

import AskAnswer from "pages/communication/AskAnswer";
import AskManager from "pages/communication/AskManager";
import SuggestionAnswer from "pages/communication/SuggestionAnswer";
import SuggestionManager from "pages/communication/SuggestionManager";

export function getCommunicationRoutes() {
  return (
    <Route path="/communication">
      <Route path="suggestion" element={<SuggestionManager />} />
      <Route path="suggestion/:id" element={<SuggestionAnswer />} />
      <Route path="ask" element={<AskManager />} />
      <Route path="ask/:id" element={<AskAnswer />} />
    </Route>
  );
}
